import { Broker } from "../model/brokerInformation.model";
import { Carrier } from "../model/carrier.model";
import { Group } from "../model/group.model";
import {
  EmployeeContribution,
  PlanSelection,
} from "../model/planSelection.model";
import { User } from "./userInformation.model";

export class RateTableInfo {
  constructor() {
    this.Group = new Group();
    this.Carrier = new Carrier();
    this.PlanSelection = new PlanSelection();
    this.Broker = new Broker();
    this.UserInfo = new User();
    this.EmployeeContribution = new EmployeeContribution();
  }
  Group: Group;
  Carrier: Carrier;
  Broker: Broker;
  PlanSelection: PlanSelection;
  UserInfo: User;
  IsAllPackagePlans: boolean;
  EmployeeContribution: EmployeeContribution;
}
